import type { FC } from 'react';
import { GlobalImages } from '../images';

export const LogoSlogan: FC = () => {
  return (
    <a className="flex flex-col items-center justify-center text-t3" href="/">
      <img className="w-20 mb-1" src={GlobalImages.logoWide} />
      <span>FlowUs</span>
      <span>一站式内容创作与营销平台</span>
    </a>
  );
};
